import { render, staticRenderFns } from "./dmgt.vue?vue&type=template&id=209c1182"
import script from "./dmgt.vue?vue&type=script&lang=js"
export * from "./dmgt.vue?vue&type=script&lang=js"
import style0 from "./dmgt.vue?vue&type=style&index=0&id=209c1182&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports